<template>
  <section class="action-list">
    <div class="action-list_wrapper">
      <div class="hgroup" v-if="inactive">
          <h1 class="heading1 heading1__minor">{{$t('Прошедшие акции')}}</h1>
      </div>
      <div class="hgroup" v-else>
        <h1 class="heading1" :class="empty && 'heading1__minor'" >{{$t('Текущие акции')}}</h1>
        <span class="title-info" v-if="empty">{{ $t('В настоящее время нет доступных акций') }}</span>
        <RouterLink
          v-else-if="!open"
          class="title-info title-info__link"
          :to="{ name: 'offers' }"
          @click.native="onShowAllOffers"
        >
          {{ $t('Смотреть все') }}
        </RouterLink>
      </div>
      <ul class="action-list_list" :class="open && 'action-list_list__open'" v-if="!empty">
        <Offer v-for="offer in offers" :offer="offer" :key="offer.offerId"/>
      </ul>
    </div>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import Offer from './Offer'

@Component({ components: { Offer } })
class OffersSection extends Vue {
  @Prop(Boolean) inactive
  @Prop(Boolean) open
  @Prop({ type: Array, required: true }) offers

  get empty () {
    return !this.offers.length
  }

  onShowAllOffers () {
    const linkUrl = this.$router.resolve({ name: 'offers' }).href
    this.$analytics.trackAllPromotionLinkClick({ screenId: this.$route.name, linkUrl })
  }
}

export default OffersSection
</script>

<style lang="scss" src="./styles/action-list.scss"></style>
<style lang="scss" src="./styles/action.scss"></style>
